const TEXT_KEYS = {
    META_DESCRIPTION_VALUE: 'head-meta__description',
    GAME_NAME: 'gameName'
};

export default TEXT_KEYS;
